<section class="list-skeleton-container">
  <div class="main-container">
    <ion-skeleton-text class="crumb" animated></ion-skeleton-text>
    <ion-skeleton-text class="title" animated></ion-skeleton-text>

    <div class="topper">
      <ion-skeleton-text class="search" animated></ion-skeleton-text>
      <ion-skeleton-text class="filter" animated></ion-skeleton-text>
    </div>

    <ion-skeleton-text class="subtitle" animated></ion-skeleton-text>

    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
  </div>

  <div class="side-container">
    <ion-skeleton-text class="input" animated></ion-skeleton-text>
    <div class="filter-divider"></div>
    <ion-skeleton-text class="sidebar" animated></ion-skeleton-text>
    <div class="filter-divider"></div>
    <ion-skeleton-text class="text" animated></ion-skeleton-text>
  </div>
</section>
